export default "__VITE_ASSET__CPfOQFF5__"